const navigation = {
  navbar: {
    home: "Home",
    dashboard: "Dashboard",
    profile: "Profile",
    settings: "Settings",
    signIn: "Sign In",
    signUp: "Sign Up",
    signOut: "Sign Out",
  },
  
  nav: {
    dashboard: "Dashboard",
    settings: "Settings",
    logout: "Logout"
  },
  
  app: {
    title: "Purple Star Astrology",
    subtitle: "Purple Star Astrology",
  },
};

export default navigation; 